// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fieldsList__b79 {
  display: flex;
  flex-direction: column;
  gap: calc(1.5 * var(--ring-unit));
}

.importantAsterisk__b4b {
  color: var(--ring-error-color);
}
`, "",{"version":3,"sources":["webpack://./src/common/form/form.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,iCAAiC;AACnC;;AAEA;EACE,8BAA8B;AAChC","sourcesContent":[".fieldsList {\n  display: flex;\n  flex-direction: column;\n  gap: calc(1.5 * var(--ring-unit));\n}\n\n.importantAsterisk {\n  color: var(--ring-error-color);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"fieldsList": `fieldsList__b79`,
	"importantAsterisk": `importantAsterisk__b4b`
};
export default ___CSS_LOADER_EXPORT___;
